const cards = [
  {
    title: '某知名导演新片选角内幕：多位一线明星因片酬谈崩退出',
    date: '2小时前',
    img: 'https://readdy.ai/api/search-image?query=Film%20director%20on%20movie%20set%20with%20dramatic%20lighting%2C%20casting%20call%20atmosphere%2C%20warm%20coral%20and%20gold%20tones%2C%20entertainment%20industry%20scene%2C%20editorial%20photography%20style%2C%20clean%20composition&width=640&height=480&seq=card-news-01&orientation=landscape'
  },
  {
    title: '网红主播被曝偷税漏税，直播间已被平台紧急封禁',
    date: '4小时前',
    img: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20with%20warning%20red%20alert%20visual%2C%20suspended%20broadcast%20scene%2C%20warm%20dramatic%20lighting%2C%20controversy%20atmosphere%2C%20clean%20editorial%20composition&width=640&height=480&seq=card-news-02&orientation=landscape'
  },
  {
    title: '娱乐圈模范夫妻被曝婚姻危机，双方已分居多时',
    date: '6小时前',
    img: 'https://readdy.ai/api/search-image?query=Celebrity%20couple%20silhouette%20with%20emotional%20distance%2C%20warm%20melancholy%20lighting%2C%20entertainment%20gossip%20visual%2C%20coral%20and%20amber%20tones%2C%20editorial%20magazine%20style%2C%20clean%20composition&width=640&height=480&seq=card-news-03&orientation=landscape'
  },
  {
    title: '选秀节目导师团彻底决裂，录制现场爆发激烈争吵',
    date: '8小时前',
    img: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20dramatic%20confrontation%20atmosphere%2C%20reality%20TV%20drama%2C%20warm%20golden%20spotlight%2C%20tension%20and%20conflict%20visual%2C%20clean%20editorial%20composition&width=640&height=480&seq=card-news-04&orientation=landscape'
  },
  {
    title: '当红小花片场耍大牌被曝光，多位工作人员实名控诉',
    date: '10小时前',
    img: 'https://readdy.ai/api/search-image?query=Film%20set%20behind%20the%20scenes%20with%20tense%20atmosphere%2C%20entertainment%20industry%20drama%2C%20warm%20coral%20and%20golden%20lighting%2C%20professional%20crew%20working%2C%20editorial%20photography%20style%2C%20clean%20composition&width=640&height=480&seq=card-news-05&orientation=landscape'
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-12">
          <span className="inline-block text-xs font-label tracking-wider text-primary-600 bg-primary-100 px-4 py-1.5 rounded-full mb-4 whitespace-nowrap">
            图文
          </span>
          <h2 className="font-heading text-[32px] md:text-[40px] text-foreground-950">最新爆料</h2>
          <p className="text-sm text-foreground-500 mt-3">实时追踪全网最新最热的八卦爆料，不错过任何一个瓜</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.slice(0, 3).map((card, i) => (
            <div key={i} className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:shadow-lg transition-all duration-300 cursor-pointer">
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  title={`51吃瓜网 ${card.title.substring(0, 25)}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h3 className="font-heading text-[15px] text-foreground-900 leading-snug line-clamp-2 mb-3 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <span className="text-xs text-foreground-500">{card.date}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5 max-w-[856px] mx-auto">
          {cards.slice(3).map((card, i) => (
            <div key={i + 3} className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:shadow-lg transition-all duration-300 cursor-pointer">
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  title={`51吃瓜网 ${card.title.substring(0, 25)}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h3 className="font-heading text-[15px] text-foreground-900 leading-snug line-clamp-2 mb-3 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <span className="text-xs text-foreground-500">{card.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}